/**
 * Instantiation of MediaDispatcher for this site.
 */
import MediaDispatcher from '../../lib/browser/MediaDispatcher.js';
export default new MediaDispatcher(['desktop', 'tablet', 'tablet-portrait', 'mobile', 'mobile-portrait']);
